<template>
  <div>
    <v-tabs :value="currentTabIndex" @change="changeTab" background-color="transparent"
      class="bg-white mb-5 rounded pl-0">
      <v-tab v-for="tabItem in tabs" :tabindex="tabItem.index" :key="tabItem.index" @click="loadRoute(tabItem.routeName)"
        :disabled="disableTabs.find(x => x.i == tabItem.index).disabled">{{ tabItem.label }}</v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { _alert } from "@/_helpers/function.js";

export default {
  components: {},
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("ROOM_INFOMATION"),
          routeName: "chainRoomInformation"
        },
        {
          index: 1,
          label: this.$t("ROOM_AMENITIES"),
          routeName: "chainRoomAmenities"
        }
      ],
      data: {},
      newId: null,
      disableTabs: [
        { i: 0, disabled: false },
        { i: 1, disabled: false },
        { i: 2, disabled: false }
      ]
    };
  },
  created() {
    // this.initialize();
    if (!this.$route.params.id) {
      return false;
    }
  },
  watch: {},
  methods: {
    async initialize() {
      let roomId = this.$route.params.id;
      if (!roomId) {
        this.disableTabs = [
          { i: 0, disabled: false },
          { i: 1, disabled: true },
          { i: 2, disabled: true }
        ];
        // this.data = {
        //   image: null,
        //   defaultPrice: null,
        //   weekendRate: null,
        //   maxAdults: 1,
        //   maxChildren: 0,
        //   totalRooms: null,
        //   roomSize: null,
        //   numberOfExtraBeds: 0,
        //   i18ns: [
        //     {
        //       lang: "vi",
        //       name: "",
        //       description: ""
        //     },
        //     {
        //       lang: "en",
        //       name: "",
        //       description: ""
        //     }
        //   ],
        //   operationBedTypes: [
        //     {
        //       typeId: 1,
        //       operation: 0,
        //       quantity: 1
        //     }
        //   ],
        //   amenites: [],
        //   viewIds: [],
        //   operationBedTypes: []
        // };
        return true;
      }

      // if (roomId != "00000000-0000-0000-0000-000000000000") {
      //   await service.getRoomDetail(roomId).then(res => {
      //     if (res.responseCode == 0) {
      //       this.data = res.data;
      //     }
      //   });
      // }
    },
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
